<template>
  <div id="backBAnQ" class="black">
    <div class="container">
      <a href="//www.banq.qc.ca" class="white-text valign-wrapper">
        <span class="hide">Allez sur le site de la Bibliothèque et Archives nationales du Québec</span>
        <i class="material-icons" aria-hidden="true">chevron_left</i>
        Bibliothèque et Archives nationales du Québec
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "BanqBack",
  data: () => ({})
};
</script>
<style lang="scss" scoped>
#backBAnQ {
  .container {
    a{
      font-size: 14px;
    }

    @media (min-width: 768px) {
      line-height: 40px;
      a{
        font-size: inherit;
      }

    }
  }
}


</style>
